export const initialQuestion = {};

export const initialPaginateQuestions = {
  pageIndex: 1,
  pageSize: 5,
  totalCount: 0,
  list: [],
};
